/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { ButtonGroup } from "@mui/material";

/**
 * @typedef {import("@mui/material").ButtonGroupProps} ButtonGroupProps
 * @typedef {import("react").ReactNode} ReactNode
 * @typedef {ButtonGroupProps & {children: ReactNode}} ToolbarButtonGroupProps
 */

/**
 * @param {ToolbarButtonGroupProps} props
 */
const ToolbarButtonGroup = (props) => {
    
    const { children, ...otherProps } = props;
    return (
        <ButtonGroup
            sx={{ backgroundColor: "white" }}
            {...otherProps}
        >
            {children}
        </ButtonGroup>
    );
};
export { ToolbarButtonGroup };
